// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__74ty7","newExpiryDate":"styles_newExpiryDate__1IlKZ","footer":"styles_footer___3Qhn"};